import _ from 'lodash';

const SETTINGS_PREFIX = 'settings:';

/**
 * Resolve a template-configured microservice action ({ api, url, token }) into
 * what a request needs. `url` and `token` may point at CMS settings with the
 * `settings:<key>` prefix (e.g. `settings:private:otto-microservice-...-url`),
 * the convention of every microservice entry in the template config.
 *
 * Returns null when the action is missing or its URL cannot be resolved, so a
 * caller never posts to "undefined".
 */
export const resolveMicroserviceAction = (action, settingValues) => {
    if (!action) return null;

    const resolve = value => (typeof value === 'string' && value.startsWith(SETTINGS_PREFIX)
        ? _.get(settingValues, value.substr(SETTINGS_PREFIX.length))
        : value);

    const url = resolve(action.url);
    if (!url) return null;

    const token = resolve(action.token);

    return {
        api: (action.api || 'rest').toLowerCase(),
        url,
        config: token ? { headers: { Authorization: `Bearer ${token}` } } : undefined,
    };
};
